import * as React from "react";
import type { SVGProps } from "react";
const SvgShop = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="M10 3c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v8h2.5v1.563c0 2.484-2.016 4.5-4.5 4.5H9.672l-1.176 1.96c.137.137.25.301.336.477h7.836a1.752 1.752 0 0 1 3.332.75 1.748 1.748 0 0 1-3.48.25H8.98a1.748 1.748 0 0 1-3.48-.25 1.752 1.752 0 0 1 2.121-1.71l.887-1.477H5.5v-7.75A1.31 1.31 0 0 0 4.188 8H3V7h1.188A2.31 2.31 0 0 1 6.5 9.313v6.75H16a3.5 3.5 0 0 0 3.5-3.5V12H8.531a.5.5 0 0 1-.5-.5c0-.277.223-.5.5-.5H10Zm1 8h6V3h-6Zm-3 9.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M12 4.5c0-.277.223-.5.5-.5h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3a.5.5 0 0 1-.5-.5M12 9h1.5v1H12Zm2.5 0H16v1h-1.5Zm3.75 10.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fillOpacity: 1,
            }}
        />
    </svg>
);
export default SvgShop;
